import React from 'react';
import pointsIcon from '../assets/points_icon.png';

export default function StatsOverlay({ title, stats, type, timeframe, onTimeframeChange }) {
  const isShop = type === 'shop';
  const s = isShop ? stats.shop : stats.betting;

  return (
    <div className="stats-overlay-content">
      <h3>{title}</h3>
      
      {isShop && (
        <div className="timeframe-switcher mini">
          <button className={timeframe === 'alltime' ? 'active' : ''} onClick={() => onTimeframeChange('alltime')}>Все время</button>
          <button className={timeframe === 'monthly' ? 'active' : ''} onClick={() => onTimeframeChange('monthly')}>Сезон</button>
        </div>
      )}

      <div className="stats-grid">
        {isShop ? (
          <>
            <StatItem label="Потрачено всего" value={s.totalSpent} />
            <StatItem label="Потрачено в рулетке" value={s.rouletteSpent} />
            <StatItem label="Выиграно в рулетке" value={s.rouletteWon} color="green" />
            <StatItem label="Джекпотов" value={s.jackpots} isPoints={false} color="gold" />
            <StatItem label="Куплено XP-бустеров" value={s.xpBoostersCount} isPoints={false} />
            <StatItem label="Куплено PRO-бустеров" value={s.proBoostersCount} isPoints={false} color="blurple" />
          </>
        ) : (
          <>
            <StatItem label="Потрачено на ставки" value={s.totalSpent} />
            <StatItem label="Выиграно со ставок" value={s.totalWon} color="green" />
            <StatItem label="Всего ставок" value={s.count} isPoints={false} />
            <StatItem label="Победных" value={s.winsCount} isPoints={false} color="green" />
            <StatItem 
                label="Любимая команда" 
                value={s.favoriteTeam.name} 
                subValue={s.favoriteTeam.count > 0 ? `${s.favoriteTeam.count} ставок` : ''}
                isPoints={false} 
                color="blurple" 
            />
            <StatItem 
                label="Пиковый выигрыш" 
                value={s.biggestWin.value} 
                subValue={s.biggestWin.reason}
                color="green" 
            />
            <StatItem 
                label="Крупный проигрыш" 
                value={s.biggestLoss.value} 
                subValue={s.biggestLoss.reason}
                color="red" 
            />
          </>
        )}
      </div>
    </div>
  );
}

const StatItem = ({ label, value, subValue = '', isPoints = true, color = '' }) => (
  <div className={`stat-item-row ${color} ${subValue ? 'has-sub' : ''}`}>
    <div className="stat-label-group">
        <span className="stat-label">{label}</span>
        {subValue && <span className="stat-sub-value">{subValue}</span>}
    </div>
    <span className="stat-value">
      {value} {isPoints && <img src={pointsIcon} className="points-icon" alt="" />}
    </span>
  </div>
);